import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OptionsList, OptionsListGridItem } from 'src/app/models/optionsList.model';
import { AnswerOptionItem } from '../../../models/answerOptionItem.model';
import { environment } from 'src/environment';
import { PageResult } from 'src/app/shared/models/pageResult';
import { SelectedFilter } from 'src/app/shared/models/filter.model';
@Injectable({
  providedIn: 'root'
})
export class OptionsListApiService {

  #httpservice = inject(HttpClient);
  //#baseUrl = inject(ConfigurationService).config.serverUrl;
  #baseUrl = `${environment.apiUrl}/optionsLists`;

  getAllOptionsLists = () => { return this.#httpservice.get<OptionsList[]>(`${this.#baseUrl}/getAll`); }

  getSavedList = (page: number, selectedFilter: any) => {
    return this.#httpservice.post<PageResult<OptionsListGridItem>>(`${this.#baseUrl}/get`, { paging: page, selectedFilter });
  }


  getItemsByListId = (guid: string) => { return this.#httpservice.get<AnswerOptionItem[]>(`${this.#baseUrl}/getItemsByListId/${guid}`); }
  getListWithItemById = (guid: string) => { return this.#httpservice.get<OptionsList>(`${this.#baseUrl}/getListWithItemById/${guid}`); }

  createNewList = (optionsList: OptionsList) => { return this.#httpservice.post<OptionsList>(`${this.#baseUrl}/createList`, optionsList); }
  duplicateList = (guid: string, name: string) => { return this.#httpservice.post<OptionsList>(`${this.#baseUrl}/duplicateList`, {guid, name}); }
  updateList = (optionsList: OptionsList) => { return this.#httpservice.post<OptionsList>(`${this.#baseUrl}/updateList`, optionsList); }
  ChangeListStatusById = (guid: string) => { return this.#httpservice.delete<number>(`${this.#baseUrl}/changeListStatus/${guid}`); }

  deleteItemFromList = (guid: string) => { return this.#httpservice.delete<AnswerOptionItem>(`${this.#baseUrl}/deleteItemFromList/${guid}`); }
  addItemToList = (listId: string, answerOptionItem: AnswerOptionItem) => { return this.#httpservice.post<AnswerOptionItem>(`${this.#baseUrl}/addItemToList/${listId}`, answerOptionItem); }
}
